import { z } from "zod";

export const ApiKeysSearchParamsSchema = z.object({
  page: z.coerce.number().int().min(1).optional(),
  search: z.string().optional(),
});

export type ApiKeysSearchParams = z.infer<typeof ApiKeysSearchParamsSchema>;
